var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPrevious = function SvgPrevious(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 426.667 426.667",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "shapePath1",
    d: "M365.5,375.23 L365.5,45.6512 L92.1168,210.445 L365.5,375.23 Z",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "shapePath2",
    d: "M92.485,25.5 L60.4999,25.5 L60.4999,400.5 L92.485,400.5 L92.485,25.5 Z",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fillOpacity: 1
    }
  }));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrevious, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/previous.f2473b20.svg";
export { ForwardRef as ReactComponent };